import showdown from 'showdown';

/**
 * Converts markdown text to HTML using showdown.
 *
 * @param {string} text - The markdown text to convert
 * @return {string} The HTML output
 */
export function convertMarkdownToHtml(text) {
  if (!text) return '';

  const converter = new showdown.Converter();
  converter.setOption('disableForced4SpacesIndentedSublists', true);
  converter.setOption('simplifiedAutoLink', true);
  converter.setOption('openLinksInNewWindow', true);
  converter.setOption('excludeTrailingPunctuationFromURLs', true);

  return converter.makeHtml(text);
}
